import React, { Component } from 'react'
import { DropTarget } from 'react-dnd'

export default DropTarget(
  'square',
  {
    drop: (props, monitor) => {
      const message = `Dropped: ${monitor.getItem().color}`
      document.getElementById('console').innerHTML += `${message}<br />`
    },
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }),
)(
  class Basket extends Component {
    render() {
      const isOver = this.props.isOver
      const canDrop = this.props.canDrop
      const connectDropTarget = this.props.connectDropTarget
      const style = {
        backgroundColor: isOver && canDrop ? '#f3f3f3' : '#cccccc',
        border: '1px dashed black',
        display: 'inline-block',
        width: 100,
        height: 100,
        margin: 10,
      }

      return connectDropTarget(<div className="square" style={style} />)
    }
  },
)
